// src/hooks/useOpenProModal.ts (or a similar path)
import { useDispatch } from "react-redux";
import mixpanel from "@/shared/lib/mixpanel";
import { useMe, useCurrentOrganization } from "@/Hooks"; // Adjust path
import { saveModeActions } from "@/entities/saveMode";

export const useOpenProModal = () => {
  const dispatch = useDispatch();
  const { me } = useMe();
  const currentOrganization = useCurrentOrganization();

  const openProModal = (source: string) => {
    mixpanel.track("Billing Modal Opened", {
      source: source,
      UserEmail: me?.email || "",
      OrganizationID: currentOrganization?.uuid || "",
      // Add any other relevant properties
    });
    dispatch(saveModeActions.activeProModal());
  };

  return openProModal;
};
